const annoWidth = 240;
const annoHeight = 125;
const menuHeight = 54;


/**
 * Vital Source Events
 */
const VitalSourceEvents = {
  'book:click': 'VSEVENT_BOOK_CLICK',
  'book:navigationRequested': 'VSEVENT_BOOK_NAVIGATION_REQUESTED',
  'book:selectionMade': 'VSEVENT_BOOK_SELECTION_MADE',
  'book:selectionWithPosition': 'VSEVENT_BOOK_SELECTION',
  'book:pagebreak': 'VSEVENT_BOOK_PAGE_BREAK',
  'book:selectionCancelled': 'VSEVENT_BOOK_SELECTION_CANCELLED',
  'book:touchstart': 'VSEVENT_BOOK_TOUCH_START',
  'book:touchend': 'VSEVENT_BOOK_TOUCH_END',
  'book:touchmove': 'VSEVENT_BOOK_TOUCH_MOVE',
  'highlight:click': 'VSEVENT_HIGHLIGHT_CLICK',
  'noteicon:click': 'VSEVENT_NOTE_ICON_CLICK',
  'page:load': 'VSEVENT_PAGE_LOAD',
  'snippet:ready': 'VSEVENT_SNIPPET_READY',
  'page:scroll': 'VSEVENT_PAGE_SCROLL'
};


export {
  annoWidth,
  annoHeight,
  menuHeight,
  VitalSourceEvents
};
